'use strict';

const _ = require('lodash');
const moment = require('moment');

const consts = require('./consts');

function precision(number, precision = 2) {
  return Number(number.toFixed(precision));
}

function getNonVariableEnvelopes(budget) {
  return _.reject(budget.envelopes, e => e.type === consts.VARIABLES_ENVELOPE_TYPE || e.type === consts.VARIABLE_INCOME_ENVELOPE_TYPE);
}

function getEnvelope(budget, envelopeName) {
  return _.find(budget.envelopes, e => e.type === envelopeName);
}

function weeksInMonth(budgetDate) {
  const momentDate = moment(budgetDate).startOf('month');
  const daysInMonth = momentDate.daysInMonth();
  return _.chain(daysInMonth)
    .range()
    .uniqBy(dayIndex =>
      momentDate.clone().add(dayIndex, 'day').week())
    .value().length;
}

function daysInWeek(weekIndex, budgetDate) {
  if (weekIndex === 0) {
    return 7 - moment(budgetDate).day();
  } else if (weekIndex === weeksInMonth(budgetDate) - 1) {
    return moment(budgetDate).endOf('month').day() + 1;
  }
  return 7;
}

function daysInMonths(budgetDate) {
  return moment(budgetDate).daysInMonth();
}

function getWeeks(budgetDate, now) {
  return _.times(weeksInMonth(budgetDate), index => {
    const startDate = index === 0 ? moment(budgetDate).startOf('month') :
      moment(budgetDate).startOf('month').add(index, 'weeks').startOf('week');
    const days = daysInWeek(index, budgetDate);
    const endDate = startDate.clone().add(days, 'days');
    return { index, startDate, endDate, days, timeframe: _getTimeframe(now, startDate, endDate) };
  });
}

function _getTimeframe(now, startDate, endDate) {
  if (moment(now) < startDate) {
    return consts.WEEK_TIMEFRAME.FUTURE;
  } else if (moment(now) < endDate) {
    return consts.WEEK_TIMEFRAME.CURRENT;
  }
  return consts.WEEK_TIMEFRAME.PAST;
}

function sumTransactions(transactions) {
  return _.sumBy(transactions, t => (t.billingAmount || 0) - (t.incomeAmount || 0)) || 0;
}

module.exports = {
  getWeeks,
  daysInWeek,
  daysInMonths,
  weeksInMonth,
  getNonVariableEnvelopes,
  getEnvelope,
  precision,
  sumTransactions,
};
